import React from 'react';
import PropTypes from 'prop-types';

// TRANSLATIONS
import { useTranslation } from 'react-i18next';

// COMPONENTS
import AutoComplete from './AutoComplete';
import TypedTagInput from './TypedTagInput';

const TagInput = ({
    entity,
    onChange,
    resource,
    service,
    errors,
    filterByType,
    ...props
}) => {
    const { t } = useTranslation();

    if (filterByType) {
        return (
            <TypedTagInput
                entity={entity}
                onChange={onChange}
                service={service}
                errors={errors}
                name="tags"
                placeholder={t('application.tags')}
                {...props}
            />
        );
    }

    return (
        <AutoComplete
            entity={entity}
            onChange={onChange}
            resource={resource}
            service={service}
            name="tags"
            searchBy="name"
            reference="tags"
            placeholder={t('application.tags')}
            isMultiple
            errors={errors}
            {...props}
        />
    );
};

TagInput.propTypes = {
    entity: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    resource: PropTypes.object.isRequired,
    service: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    filterByType: PropTypes.bool,
};

TagInput.defaultProps = {
    filterByType: false,
};

export default TagInput;
